import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import ManageArticles from './ManageArticles';
import DashboardLayout from '../../Layout/DashboardLayout';

export default function ManageArticlesWrapper() {
    const { category } = useParams();

    const categoryMap = {
        chienky: 1,
        luocsu: 2,
    };

    const categoryId = categoryMap[category];

    if (!categoryId) return <Navigate to="/dashboard" />;

    return (
        <DashboardLayout>
            <ManageArticles categoryId={categoryId} />
        </DashboardLayout>
    )
}